import React from "react";

const Section = ({ children, bgColor, bgImage, className ,customPaddings ,crosses}) => {
  const sectionStyle = {
    backgroundColor: bgColor,
    backgroundImage: bgImage ? `url(${bgImage})`:"",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
 
    <div className={` w-full ${className}  py-10 lg:py-16 xl:py-20`}>
      <div className="  items-center container     lg:flex"
      style={sectionStyle}>
   {children}</div>
    </div>
  );
};

export default Section;